import { useState } from "react";
import { unique } from "util/support";
import { ReviewableAction } from "./types";

export const useAction = () => {
    const [actions, setActions] = useState<Array<ReviewableAction>>([]);

    const approve = () => setActions(actions => unique([...actions, ReviewableAction.Approve]));

    const reject = () => setActions(actions => unique([...actions, ReviewableAction.Reject]));

    const edit = () => setActions(actions => unique([...actions, ReviewableAction.Edit]));

    const comment = () => setActions(actions => unique([...actions, ReviewableAction.Comment]));

    const reset = (action: ReviewableAction) => (
        setActions(actions => actions.filter(a => !Object.is(a, action)))
    );

    const resetAll = () => setActions([]);

    const hasAction = (action: ReviewableAction) => actions.includes(action);

    return {
        actions,
        edit,
        approve,
        reject,
        comment,
        reset,
        resetAll,
        hasAction
    };
};

export default useAction;
